import { filter, isArray } from 'lodash';

/*
    How to use it:

    import {parentChildList} from  '../../../../../../lib/parentChildList';

    ...

    constructor() {
        this.parentChildHandlers = parentChildList();
    }

    render() {

        const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
            parentProps: this.handleUIDropdown(...),
            childProps: this.handleUIDropdown(...),
        });

        <DropDownMenu {...industryTypeProps} />
        <DropDownMenu {...segmentTypeProps} />

        ...
    }

    ...

*/
export function parentChildList(defaultToValue = true) {

  let currentOption;

  return ({parentProps, childProps}) => {

      function parent() {

          const {onChange, onBlur, value, defaultValue, ...othersParentProps} = parentProps;

          if(defaultToValue) {
            currentOption = value || defaultValue;
          }


          return {
              ...othersParentProps,
              value,
              defaultValue,
              onChange: (event, value, primaryText) => {
                if(onChange) {
                    currentOption = value;
                    setTimeout(() => resetChildValue(event), 300);
                    return onChange(event, value, primaryText);
                }
              },
              onBlur: (event, value, primaryText) => {
                if(onBlur) {
                    currentOption = value;
                    setTimeout(() => resetChildValue(event), 300);
                    return onBlur(event, value, primaryText);
                }
              }
          };
      }

      function resetChildValue(event) {

        const {onChange, onBlur} = childProps;

        if(onChange) {
            onChange(event, undefined);
        }

        if(onBlur) {
            onBlur(event, undefined);
        }

      }

      function child() {

          const {menuItems, ...otherChildProps} = childProps;

          return {
              ...otherChildProps,
              menuItems: filter(menuItems, item => {

                if(isArray(currentOption)) {
                    return currentOption.includes(item.parentId) || !item.parentId;
                }
                
                return currentOption === item.parentId || !item.parentId;

              })
          };
      }

      return {
        parent: parent(),
        child: child()
      };

  };

}



// WEBPACK FOOTER //
// ./shared/lib/parentChildList.js